export default "__VITE_ASSET__a9e6bc63__"